import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsPauseFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.46 4.92H10.26V19H6.46V4.92ZM13.74 4.92H17.54V19H13.74V4.92Z" />
    </SvgIcon>
  );
});
